import {AlertController, ToastController, NavController} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {AgentAutoRegNewPage} from "../agentAutoRegNew/agentAutoRegNew";
import {AgentAutoRegEditPage} from "../agentAutoRegEdit/agentAutoRegEdit";
import {CommonUtil} from "../../util/commonUtil";

@Component({
    templateUrl: 'agentAutoReg.html',
    selector: 'agent-auto-reg-page',
})
export class AgentAutoRegPage {
    reslist: any = [];
    initData: any;
    listnum: number;

    pointssc: number = 0.0;

    constructor(private nav: NavController, private toastCtrl: ToastController, private alertCtrl: AlertController, private userService: UserService) {
    }

    addNewLink() {
        let requestData: any = {
            rpointssc: this.pointssc,
        };
        this.userService.agentAutoRegNew(requestData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Tạo liên kết thành công."
                });
                this.userService.agentUserAutoRegList(undefined, this.alertCtrl).then(data => {
                    if (!data["msg"]) {
                        this.reslist = data["reslist"];
                    } else {
                        AppDialog.alert({
                            alertCtrl: this.alertCtrl,
                            message: data["msg"]
                        });
                    }
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    registerFn() {
        if (this.listnum < 3) {
            this.addNewLink();
        } else {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Mỗi hội viên chỉ có 1 liên kết đăng ký!"
            });
        }
    }

    copy(url: string) {
        CommonUtil.copyToClipboard(url, this.toastCtrl);
    }

    edit(item: any) {
        this.nav.push(AgentAutoRegEditPage, {
            initData: this.initData,
            item: item
        });
    }

    ionViewWillEnter() {
        this.userService.agentUserAutoRegList(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                data["reslist"].map(item => {
                    item.pointssc = (item.pointssc * 100).toFixed(1);
                    item.point115 = (item.point115 * 100).toFixed(1);
                    item.pointdp = (item.pointdp * 100).toFixed(1);
                    return item;
                });
                this.listnum = data["listnum"];
                this.reslist = data["reslist"];
                this.initData = data;
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    blankLink(link: any) {
        window.open(link, '_system', 'location=yes')
    }
}



// WEBPACK FOOTER //
// ./src/pages/agentAutoReg/agentAutoReg.ts